import { Box, Grid, GridProps, Typography } from "@mui/material";
import React from "react";

type CheckInMoodCardProps = GridProps & {
    title: string;
    img: string;
    selected?: string;
    selectMood: () => void;
};

export const CheckInMoodCard: React.FC<CheckInMoodCardProps> = (props: CheckInMoodCardProps): JSX.Element => {
    const { title, img, selected, selectMood, ...gridProps } = props;

    const handleClick = () => {
        selectMood();
    };

    // If used in reason step with lg/sm props, render as Grid item
    if (gridProps.lg || gridProps.sm) {
        return (
            <Grid
                {...gridProps}
                item
                justifyContent="center"
                style={{
                    display: "flex",
                    cursor: "pointer",
                    backgroundColor: `${selected === title ? "grey" : "transparent"}`,
                }}
            >
                <Box display="flex" flexDirection={"column"} justifyContent="center" onClick={handleClick}>
                    <img src={img} height="150px" width={"150px"} />
                    <Typography variant="h4" align="center">
                        <strong>{title}</strong>
                    </Typography>
                </Box>
            </Grid>
        );
    }

    // For mood step, render as simple Box (Grid item wrapper is outside)
    return (
        <Box
            display="flex"
            flexDirection={"column"}
            alignItems="center"
            justifyContent="center"
            onClick={handleClick}
            style={{
                cursor: "pointer",
            }}
        >
            <img src={img} height="150px" width={"150px"} />
            <Typography variant="h4" align="center">
                <strong>{title}</strong>
            </Typography>
        </Box>
    );
};
